import * as yup from 'yup';

const NAME_MAX_LENGTH = 30;

export const editGroupAdminSchema = yup.object({
  name: yup
    .string()
    .trim()
    .max(NAME_MAX_LENGTH, `Máximo ${NAME_MAX_LENGTH} caracteres excedido.`)
    .required('Nome é obrigatório'),
  storeGroupIds: yup.array().of(yup.string()).min(1, 'Selecione ao menos um grupo'),
});
